module.exports = __webpack_public_path__ + "img/arrow-right.d44b0ef5.svg";